import React from "react";
import UseForm from "../UseForm";
export default function Main(){

  return (    
    <UseForm type={"company"}/>
  )
}